import httpClient from './../../../httpClient';

const END_POINT = 'v3/country';

const getActiveCountries = () => httpClient.get(`${END_POINT}`);

export {
    getActiveCountries,
}